(function () {
  var EXIT_MS = 220;
  var hideTimer;
  var removeTimer;

  function show(message, opts) {
    var el = document.getElementById('snackbar');
    if (!el || !message) return;

    var duration = (opts && opts.duration) || 2500;

    clearTimeout(hideTimer);
    clearTimeout(removeTimer);

    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.setAttribute('data-visible', 'true');
    });

    hideTimer = setTimeout(function () {
      el.removeAttribute('data-visible');
      removeTimer = setTimeout(function () {
        el.hidden = true;
      }, EXIT_MS);
    }, duration);
  }

  window.showSnackbar = show;

  document.addEventListener('snackbar:show', function (e) {
    if (e.detail && e.detail.message) show(e.detail.message, e.detail);
  });

  // Capture phase: openable-element calls stopPropagation on [data-action="close"]
  // clicks, so a bubble-phase listener here would never see them.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-snackbar-message]');
    if (trigger) show(trigger.getAttribute('data-snackbar-message'));
  }, true);
})();
